import { buildDeserializer, buildSerializer } from "lib/serializerUtils";
import { passThroughDeserializer } from "lib/reducers";

export const serializeRuleSet = buildSerializer(
  passThroughDeserializer,
  "ruleSet",
);
export const deserializeRuleSet = buildDeserializer(
  passThroughDeserializer,
  "ruleSet",
);
